module.exports = __webpack_public_path__ + "static/media/10.2b4e63e3.svg";